import MenuItem from "~/cabinet/vue/interface/menu/MenuItem";

export default class MenuItemHref extends MenuItem {
    constructor(href: string | (() => string), descr: string) {
        super("", descr);
        this.linkAddress = href;
    }
}